<div class="page-container product-shelf-container container">
  @if (programChooser) {
    <div>
      <div>
        <h1 class="header mb-2">Product Shelf</h1>
        <h4>Filter on Program Name</h4>
      </div>
      <mat-form-field class="w-50">
        <mat-select [(ngModel)]="programName">
          @for (option of programOptions; track option) {
            <mat-option [value]="option">
              {{ option }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="col-12 buttons">
        <button
          type="button"
          mat-raised-button
          class="ms-2"
          color="accent"
          [disabled]="!programName"
          (click)="sendProgramOut()"
        >
          <mat-icon aria-label="Search Using Program Name">search</mat-icon>
          Search Using Program Name
        </button>
      </div>
    </div>
    <h2 class="program-filter-divider">OR</h2>
    <div>
      <div>
        <h4>Apply a Saved Filter</h4>
      </div>
      <app-manage-filters
        [grid]="gridConfig.gridName"
        [searchOnly]="true"
        (sendTemplateOut)="selectTemplate($event)"
      />

      <div class="col-12 buttons">
        <button
          type="button"
          mat-raised-button
          class="ms-2"
          color="accent"
          [disabled]="!templateDataToUse"
          (click)="sendTemplateOut()"
        >
          <mat-icon aria-label="Search Using Saved Filter Template">
            search
          </mat-icon>
          Search Using Saved Filter Template
        </button>
      </div>
    </div>
    <ngx-loading [show]="loading" />
  } @else {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    >
      <span class="custom-grid-control">
        <button
          color="primary"
          type="button"
          mat-button
          class="me-0 ms-2"
          [disabled]="disableCompare()"
          (click)="compare()"
        >
          <mat-icon class="me-2"> compare_arrows </mat-icon>
          Compare Products
        </button>

        <button
          color="primary"
          type="button"
          mat-button
          class="me-0 ms-2"
          [disabled]="disableAlternatives()"
          (click)="generateAlternatives()"
        >
          <mat-icon class="me-2">upcoming</mat-icon>
          Generate Alternatives
        </button>

        @if (rights.includes('CalculateCostValueIWShelf')) {
          <button
            color="primary"
            type="button"
            mat-button
            class="me-0 ms-2"
            (click)="calcFields()"
          >
            <mat-icon class="me-2">payments</mat-icon>
            Calculate Cost/Value
          </button>
        }
      </span>
    </app-rb-grid>
  }
</div>
<ngx-loading [show]="loading" />
